"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIconStyles = exports.iconStyles = void 0;
var styles_1 = require("@hawkins/styles");
var iconStyles = function () { return ({
    /** Class name to apply to the root of the component when the size is `large` */
    large: {},
    /** Class name to apply to the root of the component when the size is `small` */
    small: {},
    /** Class name to apply to the root of the component */
    root: {},
}); };
exports.iconStyles = iconStyles;
exports.useIconStyles = (0, styles_1.makeStyles)((0, exports.iconStyles)(), { name: 'Hawkins-Icon' });
